import Joi from 'joi';

export interface IRunQuickQueryParams {
  name: string;
  fromTimestamp: number;
  toTimestamp: number;
}

export const runQuickQueryParamsSchema = Joi.object({
  name: Joi.string().required(),
  fromTimestamp: Joi.number().required(),
  toTimestamp: Joi.number().required(),
});
